import { ComingSoonPanel, IconArchive } from '@shared/ui';

/**
 * What this client is charged, and what it has already paid.
 *
 * Waiting on the same thing Product settings waits on: a subscription has no
 * amount until the add-ons it bundles carry prices. Nothing on this tab is a
 * read the app could do today against a store that already holds the answer.
 */
export function ClientBillingTab() {
    return (
        <ComingSoonPanel
            icon={<IconArchive className="size-6" />}
            title="Billing"
            blurb="The client's plan and billing contact, the recurring total its active add-ons come to, and the invoice history behind it. It follows the per-tenant subscriptions Product settings is waiting for."
        />
    );
}
